import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

const StatusWisePrint = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [statusName, setStatusName] = useState("");
  const [query, setQuery] = useState(null);

  useEffect(() => {
    document.title = "Student Status Change — Print";

    const urlParams = new URLSearchParams(window.location.search);
    const q = {
      startDate: urlParams.get("StartDate") || "",
      endDate: urlParams.get("EndDate") || "",
      wingId: urlParams.get("Wing_Id") || "",
      statusTypeId: urlParams.get("Status") || "",
      reappear: urlParams.get("Reappear") === "1",
    };
    setQuery(q);

    const statusId = parseInt(String(q.statusTypeId).trim(), 10);
    if (!q.startDate || !q.endDate || !Number.isFinite(statusId) || statusId <= 0) {
      setLoading(false);
      return;
    }

    const wingNum = parseInt(String(q.wingId).trim(), 10);

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Reports/GetStatusChangeList",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        StartDate: q.startDate,
        EndDate: q.endDate,
        Wing_Id: Number.isFinite(wingNum) ? wingNum : 0,
        Status_Type_Id: statusId,
        Reappear: q.reappear,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setStatusName(response.data.statusName || "");
        } else {
          setLedger([]);
        }
        setLoading(false);
      })
      .catch(() => {
        setLedger([]);
        setLoading(false);
      });
  }, []);

  const title =
    query && statusName
      ? `${statusName}${query.reappear ? " (Reappear)" : ""} — ${moment(query.startDate).format("DD/MM/YYYY")} to ${moment(query.endDate).format("DD/MM/YYYY")}`
      : "Student Status Change Report";

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.Registration_No}</td>
          <td>{item.Student_Name}</td>
          <td>{item.Status_Type_Name}</td>
          <td>
            {[item.Wing_Name, item.Class_Name, item.Section_Name]
              .filter(Boolean)
              .join(", ")}
          </td>
          <td>{moment(item.Dated).format("DD/MM/YYYY")}</td>
          <td>{item.Modified_By}</td>
          <td>{item.Remarks}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="7">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <Page orientation="portrait" size="a4">
      <table className="table table-sm table-bordered table-print">
        <thead>
          <tr>
            <th colSpan={8}>
              <PrintHeader title={title} />
            </th>
          </tr>
          <tr>
            <th>Sr.#</th>
            <th>Reg. No</th>
            <th>Student Name</th>
            <th>Status</th>
            <th>Class Details</th>
            <th>Change Date</th>
            <th>Modified By</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="8" className="text-center">
                <Spinner animation="border" role="status" />
              </td>
            </tr>
          ) : (
            renderLedger()
          )}
        </tbody>
      </table>
    </Page>
  );
};

export default StatusWisePrint;
